var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"full col-lg-8 mx-auto p-3 py-md-5"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }